import Vue from 'vue';
import Router from 'vue-router';
import Assets from './views/Assets.vue';
import Device from './views/Device.vue';
import Login from './views/Login.vue';
import UserProfile from './views/UserProfile.vue';
import Access from './views/Access.vue';
import Nfresh from './views/Nfresh.vue';
import Ntag from './views/Ntag.vue';
import Subscriptions from './views/Subscriptions.vue';
import SingleSubscription from './views/SingleSubscription.vue';
import NfreshSingleProbe from './components/nfresh/NfreshSingleProbe.vue';
import NfreshSubs from "@/components/nfresh/NfreshSubs.vue";
import { curPref, Preferences } from '@/services/Preferences';
import NfreshProbes from "@/components/nfresh/NfreshProbes.vue";
import NfreshSingleSubscription from "@/components/nfresh/NfreshSingleSubscription.vue";
import LoraParsers from './views/LoraParsers.vue';

import LoraParserNew from "@/components/loraParser/LoraParserNew.vue";
import LoraParserList from "@/components/loraParser/LoraParserList.vue";
import LoraParserEdit from "@/components/loraParser/LoraParserEdit.vue";
import LoraParserTest from "@/components/loraParser/LoraParserTest.vue";
import LoraParserDelete from "@/components/loraParser/LoraParserDelete.vue";
import DeviceImages from "@/views/DeviceImages.vue";
import GroupConfigure from "@/views/GroupConfigure.vue";
import BaseStationPage from "@/views/BaseStationPage.vue";
import NtagTags from "@/components/ntag/NtagTags.vue";
import NtagLocations from "@/components/ntag/NtagLocations.vue";
import NtagSingleTag from "@/components/ntag/NtagSingleTag.vue";
import NtagLocationPage from "@/components/ntag/NtagLocationPage.vue";


Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: { name: 'assets' },
    },
    {
      path: '/assets',
      name: 'assets',
      component: Assets,
    },
    {
      path: '/assets/devices/:deviceId',
      name: 'device',
      component: Device,
    },
    {
      path: '/assets/devices/:deviceId/images',
      name: 'device-images',
      component: DeviceImages,
    },
    {
      path: '/assets/group/:groupId/configure',
      name: 'configure-devices',
      component: GroupConfigure,
    },
    {
      path: '/assets/basestation/:lrrId',
      name: 'basestation',
      component: BaseStationPage,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/profile',
      name: 'profile',
      component: UserProfile,
    },
    {
      path: '/access',
      name: 'access',
      component: Access,
    },
    {
      path: '/subscriptions',
      name: 'subscriptions',
      component: Subscriptions,
    },
    {
      path: '/subscriptions/:subId',
      name: 'subscription',
      component: SingleSubscription,
    },
    {
      path: '/lora-parsers',
      component: LoraParsers,
      children: [
        {
          path: '',
          name: 'lora-parser-list',
          component: LoraParserList
        },
        {
          path: 'new',
          name: 'lora-parser-new',
          component: LoraParserNew
        },
        {
          path: ':loraParserId/edit',
          name: 'lora-parser-edit',
          component: LoraParserEdit
        },
        {
          path: ':loraParserId/test',
          name: 'lora-parser-test',
          component: LoraParserTest
        },
        {
          path: ':loraParserId/delete',
          name: 'lora-parser-delete',
          component: LoraParserDelete
        }
      ]
    },
    {
      path: '/applications/nfresh',
      component: Nfresh,
      redirect: to => Object.assign({}, {name: defaultNfreshPage()}),
      children: [
        {
          path: 'subscriptions',
          name: 'applications-nfresh-subscriptions',
          component: NfreshSubs,
        },
        {
          path: 'probes',
          name: 'applications-nfresh-probes',
          component: NfreshProbes,
        }
      ],
    },
    {
      path: '/applications/nfresh/probes/:deviceId',
      name: 'applications-nfresh-single-probe',
      component: NfreshSingleProbe,
    },
    {
      path: '/applications/nfresh/subscriptions/:subId',
      name: 'applications-nfresh-subscription',
      component: NfreshSingleSubscription,
    },
    {
      path: '/applications/ntag',
      component: Ntag,
      redirect: to => Object.assign({}, {name: defaultNtagPage()}),
      children: [
        {
          path: 'tags',
          name: 'applications-ntag-tags',
          component: NtagTags,
        },
        {
          path: 'locations',
          name: 'applications-ntag-locations',
          component: NtagLocations,
        }
      ],
    },
    {
      path: '/applications/ntag/tags/:deviceId',
      name: 'applications-ntag-single-tag',
      component: NtagSingleTag,
    },
    {
      path: '/applications/ntag/locations/:locationId',
      name: 'applications-ntag-location-page',
      component: NtagLocationPage,
    },
    {
      path: "*",
      redirect: { name: 'assets' },
    }
  ],
});

function defaultNfreshPage(){
  const pref = curPref.retrieve('v3-nfresh-cur-section', 'probes');
  switch(pref){
    case 'probes':
      return 'applications-nfresh-probes';
    case 'subscriptions':
      return 'applications-nfresh-subscriptions';
    default:
      return 'applications-nfresh-probes';
  }
}

function defaultNtagPage(){
  const pref = curPref.retrieve('v3-ntag-cur-section', 'tags');
  switch(pref){
    case 'tags':
      return 'applications-ntag-tags';
    case 'locations':
      return 'applications-ntag-locations';
    default:
      return 'applications-ntag-tags';
  }
}
export default router;
